import { render, staticRenderFns } from "./customParam.vue?vue&type=template&id=2b4508e7&scoped=true"
import script from "./customParam.vue?vue&type=script&lang=js"
export * from "./customParam.vue?vue&type=script&lang=js"
import style0 from "./customParam.vue?vue&type=style&index=0&id=2b4508e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4508e7",
  null
  
)

export default component.exports